// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

import { type Scope } from "~/hooks/useScope";
import { MUTATE_RISK_FACTORS } from "./action";

export function canMutateRiskFactors(scope: Scope): boolean {
  return scope.iamActions.includes(MUTATE_RISK_FACTORS);
}
